<div class="author__image-container">
  @if (author.portrait) {
    <img class="object-cover" [ngSrc]="author.portrait.url" alt="" fill />
  }
</div>
<div class="author__name" *cftI18n="let t">{{ t('author.from') }} {{ author.name }}</div>
